var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 197,
    rx: 20,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.466 69.6636C104.517 69.6504 104.831 69.3881 104.657 69.2869L88.6302 56.2675C82.2498 50.3162 92.3329 44.4568 98.2523 47.9571L140.914 80.9984C165.367 103.31 154.346 139.797 123.671 149.02C105.328 154.537 84.1499 148.4 72.9256 132.684C68.3666 126.3 65.003 117.694 66.3316 109.765C66.2042 109.627 65.2935 110.38 65.1192 110.519C57.5752 116.543 50.4134 123.115 42.8112 129.06C41.4283 130.142 40.0623 131.316 38.4096 131.967C28.5101 135.849 23.0948 125.817 30.2566 118.754C45.7475 106.518 61.5908 94.7223 77.0143 82.4075H50.4996C50.0855 82.4075 48.4384 81.7798 47.9905 81.5437C43.8362 79.3438 44.6345 74.573 47.88 71.9178C48.8731 71.1045 51.7007 69.6654 52.9356 69.6654H104.466V69.6636Z",
    fill: "#F37028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.521 82.4592C125.024 81.1494 141.362 95.4655 135.947 113.696C129.51 135.367 97.1454 137.82 86.0467 118.439C76.5895 101.923 89.9068 83.7784 107.521 82.4592Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.207 90.5175C121.677 89.5524 132.51 101.789 125.766 113.635C119.468 124.698 101.472 124.591 95.2804 113.513C89.2466 102.718 97.7875 91.4019 109.207 90.5175Z",
    fill: "#005486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlender);
export default __webpack_public_path__ + "static/media/blender.d85024376976e8675e75668540945fe3.svg";
export { ForwardRef as ReactComponent };